// extracted by mini-css-extract-plugin
export default {"teamInfoPageContainer":"InfoPage_teamInfoPageContainer__EtO9L","viewSelector":"InfoPage_viewSelector__bjr2s","teamPageContainer":"InfoPage_teamPageContainer__ahslZ"};